// schreibt den inhalt vom grossen logo in das kleine logo, das beim scrollen angezeigt wird
// wird nur einmal ausgefuehrt beim laden der seite
export class LogoManager {
    private logoContainer: HTMLElement | null;
    private smallLogoContainer: HTMLElement | null;

    constructor() {
        this.logoContainer = document.querySelector('.hf_logo');
        this.smallLogoContainer = document.querySelector('.logo_sticky_small');
        this.init();
    }

    public init(): void {
        if (!this.logoContainer || !this.smallLogoContainer) {
            return;
        }

        const mainImage = this.logoContainer.querySelector<HTMLImageElement>('img');
        if (!mainImage) {
            return;
        }

        const mainImageUrl = mainImage.getAttribute('data-main-image-url');
        if (!mainImageUrl) {
            return;
        }

        const smallImage = this.smallLogoContainer.querySelector<HTMLImageElement>('img');
        if (!smallImage) {
            return;
        }

        smallImage.setAttribute('src', mainImageUrl);
    }
}


